import React from 'react';
import pluralize from 'pluralize';

import type { Stats } from '../../types/stats';

const DashboardStats: React.FC<{ stats: Stats }> = ({ stats }) => {
  const totalSprks = stats?.total_sprks || 0;
  const totalMemories = stats?.total_memories || 0;
  const totalTimelines = stats?.total_timelines || 0;
  const totalViews = stats?.total_views || 0;
  const totalReactions = stats?.total_reactions || 0;
  const totalComments = stats?.total_comments || 0;

  return (
    <div className="dashboard-stats wa-grid wa-gap-s inner">
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalSprks}</h2>
          <span className="dashboard-stat-label">{pluralize('SPRK', totalSprks)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalMemories}</h2>
          <span className="dashboard-stat-label">{pluralize('Memory', totalMemories)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalTimelines}</h2>
          <span className="dashboard-stat-label">{pluralize('Timeline', totalTimelines)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalViews}</h2>
          <span className="dashboard-stat-label">{pluralize('View', totalViews)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalReactions}</h2>
          <span className="dashboard-stat-label">{pluralize('Reaction', totalReactions)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="dashboard-stat-value">{totalComments}</h2>
          <span className="dashboard-stat-label">{pluralize('Comment', totalComments)}</span>
        </div>
      </wa-card>
    </div>
  );
}

export default DashboardStats;
